/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
export var AuthActionsTypes;
(function (AuthActionsTypes) {
    AuthActionsTypes["AUTH_REQUEST"] = "AUTH_REQUEST";
    AuthActionsTypes["AUTH_SUCCESS"] = "AUTH_SUCCESS";
    AuthActionsTypes["AUTH_FAILURE"] = "AUTH_FAILURE";
    AuthActionsTypes["AUTH_RESET"] = "AUTH_RESET";
    AuthActionsTypes["LOGOUT"] = "LOGOUT";
})(AuthActionsTypes || (AuthActionsTypes = {}));
export var authRequestAction = function (username, password) {
    return {
        type: AuthActionsTypes.AUTH_REQUEST,
        payload: {
            username: username,
            password: password,
        },
    };
};
export var authSuccessAction = function (response) {
    return {
        type: AuthActionsTypes.AUTH_SUCCESS,
        payload: {
            response: response,
        },
    };
};
export var authFailureAction = function (error) {
    return {
        type: AuthActionsTypes.AUTH_FAILURE,
        payload: error,
    };
};
export var authResetAction = function () {
    return {
        type: AuthActionsTypes.AUTH_RESET,
    };
};
export var authLogoutAction = function () {
    return {
        type: AuthActionsTypes.LOGOUT,
    };
};
